<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="1295.9px" height="900.3px" viewBox="0 0 1295.9 799.3" preserveAspectRatio="xMinYMin meet" style="enable-background:new 0 0 1295.9 799.3;"
         xml:space="preserve">
        <path id="cloud12" class="st0" d="M557.2,395c0.6-2.8,0.9-5.7,0.9-8.7c0-24.1-19.5-43.6-43.7-43.6c-8.8,0-17.1,2.6-23.9,7.2
	c-7.2-28.3-32.8-49.2-63.4-49.2c-29.9,0-55.1,20.1-62.9,47.4c-26.8,4-47.5,27-47.7,54.9c-11.3,8.1-18.7,21.4-18.7,36.4
	c0,24.8,20.1,44.8,44.8,44.8h208.1c24.7,0,44.8-20.1,44.8-44.8C595.5,416.8,578.9,398.2,557.2,395z"/>
        <path id="cloud11" class="st1" d="M408.6,388.6c0.3-1.4,0.4-2.9,0.4-4.4c0-12.1-9.8-22-22-22c-4.5,0-8.6,1.3-12.1,3.6
	c-3.6-14.3-16.5-24.8-31.9-24.8c-15.1,0-27.7,10.1-31.7,23.9c-13.5,2-23.9,13.6-24.1,27.7c-5.7,4.1-9.4,10.8-9.4,18.3
	c0,12.5,10.1,22.6,22.6,22.6h104.8c12.5,0,22.6-10.1,22.6-22.6C427.9,399.6,419.5,390.2,408.6,388.6z"/>
        <path id="cloud10" class="st2" d="M228.3,517.7c-0.4-2.1-0.7-4.4-0.7-6.6c0-18.3,14.9-33.2,33.2-33.2c6.7,0,13,2,18.2,5.5
	c5.5-21.5,25-37.5,48.2-37.5c22.7,0,41.9,15.3,47.9,36.1c20.4,3.1,36.1,20.5,36.3,41.8c8.6,6.2,14.3,16.3,14.3,27.7
	c0,18.8-15.3,34.1-34.1,34.1H233.3c-18.8,0-34.1-15.3-34.1-34.1C199.2,534.3,211.8,520.1,228.3,517.7z"/>
        <path id="cloud9" class="st0" d="M1024.8,406c-0.6-2.8-0.9-5.7-0.9-8.7c0-24.1,19.5-43.6,43.7-43.6c8.8,0,17.1,2.6,23.9,7.2
	c7.2-28.3,32.8-49.2,63.4-49.2c29.9,0,55.1,20.1,62.9,47.4c26.8,4,47.5,27,47.7,54.9c11.3,8.1,18.7,21.4,18.7,36.4
	c0,24.8-20.1,44.8-44.8,44.8h-208.1c-24.7,0-44.8-20.1-44.8-44.8C986.5,427.8,1003.1,409.2,1024.8,406z"/>
        <path id="cloud8" class="st3" d="M948.7,152.8c1.1-3.7,1.8-7.7,1.8-11.8c0-22.5-18.2-40.7-40.7-40.7c-16.2,0-30.1,9.5-36.7,23.2
	c-6.3-6.6-15.1-10.6-24.8-10.6c-19,0-34.4,15.4-34.4,34.4c0,1.9,0.2,3.7,0.5,5.5h-7c-16.6,0-30,13.4-30,30s13.4,30,30,30h139.2
	c16.6,0,30-13.4,30-30C976.5,166.9,964.2,153.9,948.7,152.8z"/>
        <path id="cloud7" class="st1" d="M883.9,344.1c-0.3-1.4-0.4-2.9-0.4-4.4c0-12.1,9.8-22,22-22c4.5,0,8.6,1.3,12.1,3.6
	c3.6-14.3,16.5-24.8,31.9-24.8c15.1,0,27.7,10.1,31.7,23.9c13.5,2,23.9,13.6,24.1,27.7c5.7,4.1,9.4,10.8,9.4,18.3
	c0,12.5-10.1,22.6-22.6,22.6H887.2c-12.5,0-22.6-10.1-22.6-22.6C864.6,355.1,873,345.7,883.9,344.1z"/>
        <path id="cloud6" class="st2" d="M1045.2,199.6c0.3-1.3,0.4-2.7,0.4-4.1c0-11.4-9.3-20.7-20.7-20.7c-4.2,0-8.1,1.3-11.4,3.4
	c-3.4-13.4-15.6-23.4-30.1-23.4c-14.2,0-26.1,9.5-29.9,22.5c-12.7,1.9-22.5,12.8-22.7,26.1c-5.4,3.9-8.9,10.2-8.9,17.3
	c0,11.8,9.5,21.3,21.3,21.3h98.8c11.8,0,21.3-9.5,21.3-21.3C1063.3,210,1055.4,201.1,1045.2,199.6z"/>
        <path id="cloud5" class="st0" d="M144,252.6c-0.4-1.8-0.6-3.6-0.6-5.5c0-15.3,12.4-27.8,27.8-27.8c5.6,0,10.9,1.7,15.2,4.6
	c4.6-18,20.9-31.3,40.3-31.3c19,0,35,12.8,40,30.2c17.1,2.6,30.2,17.2,30.4,34.9c7.2,5.2,11.9,13.6,11.9,23.2
	c0,15.8-12.8,28.5-28.5,28.5H148.2c-15.7,0-28.5-12.8-28.5-28.5C119.7,266.4,130.2,254.6,144,252.6z"/>
        <path id="cloud4" class="st3" d="M36.4,308.3c-1.1-3.7-1.8-7.7-1.8-11.8c0-22.5,18.2-40.7,40.7-40.7c16.2,0,30.1,9.5,36.7,23.2
	c6.3-6.6,15.1-10.6,24.8-10.6c19,0,34.4,15.4,34.4,34.4c0,1.9-0.2,3.7-0.5,5.5h7c16.6,0,30,13.4,30,30s-13.4,30-30,30H38.5
	c-16.6,0-30-13.4-30-30C8.6,322.4,20.8,309.4,36.4,308.3z"/>
        <path id="cloud3" class="st4" d="M116.8,194c0.1-0.7,0.2-1.5,0.2-2.3c0-6.4-5.2-11.6-11.6-11.6c-2.3,0-4.5,0.7-6.3,1.9
	c-1.9-7.5-8.7-13.1-16.8-13.1c-7.9,0-14.6,5.3-16.7,12.6c-7.1,1.1-12.6,7.2-12.7,14.5c-3,2.2-5,5.7-5,9.6c0,6.6,5.3,11.9,11.9,11.9
	h55.1c6.6,0,11.9-5.3,11.9-11.9C126.9,199.7,122.5,194.8,116.8,194z"/>
        <path id="cloud2" class="st4" d="M1124.1,286.9c-0.3-1.7-0.5-3.5-0.5-5.4c0-14.9,12-26.9,26.9-26.9c5.4,0,10.5,1.6,14.7,4.4
	c4.5-17.4,20.2-30.4,39.1-30.4c18.4,0,33.9,12.4,38.8,29.2c16.5,2.5,29.3,16.6,29.4,33.8c7,5,11.6,13.2,11.6,22.4
	c0,15.3-12.4,27.6-27.6,27.6h-128.3c-15.3,0-27.6-12.4-27.6-27.6C1100.5,300.3,1110.8,288.9,1124.1,286.9z"/>
        <path id="cloud1" class="st5" d="M662.7,691.3c-1.9-6.3-3-13.1-3-20c0-38,30.8-68.8,68.8-68.8c27.4,0,51,16,62,39.2
	c10.6-11.1,25.5-18,42.1-18c32.1,0,58.2,26.1,58.2,58.2c0,3.2-0.3,6.2-0.8,9.3h11.8c28,0,50.7,22.7,50.7,50.7s-22.7,50.7-50.7,50.7
	H666.3c-28,0-50.7-22.7-50.7-50.7C615.6,715,636.4,693.1,662.7,691.3z"/>
        <MiddleCaption></MiddleCaption>
        <g id="balloon">
            <a xlink:href="/home">
                <Balloon></Balloon>
            </a>
        </g>
    </svg>
</template>
<script>
import gsap from 'gsap';
import Balloon from './Balloon';
import MiddleCaption from './MiddleCaption';
  export default {
    name: 'HomePage',
    components: {
      Balloon,
      MiddleCaption,
    },
    mounted () {
        this.revealClouds();
    },
    methods: {
      revealClouds() {
        gsap.from('.cloud', {
          duration: 0.5,
          opacity: 0,
          scale: 0,
          y: 200,
          ease: 'power1',
          stagger: {
            each: 0.1,
            from: 'center'
          }
        });
      }
    }
  }
</script>
<style>
@keyframes float {
    50% {
        transform: translate3d(10px, 20px, 0px);
    }
}
svg {
    height: 100%;
    max-height: 100%;
    width: 100%;
    max-width: 1280px;
}
.st0{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}
.st1{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}
.st2{opacity:0.8;fill:none;stroke:#1F3A44;enable-background:new    ;}
.st3{fill:#F6F4DC;}
.st4{opacity:0.8;fill:none;stroke:#F6F4DC;enable-background:new    ;}
.st5{fill:#FFFFFF;}
.st6{fill:#236329;}
.st7{fill:#47B8BE;}
.st8{fill:#E6007E;}
.st9{fill:#86BC25;}
.st10{fill:#0095DB;}
.st11{fill:#E6371E;}
.st12{fill:#553415;}
.st13{fill:#1F3A44;}
#balloon {
    animation: float 3s ease-out infinite;
}
</style>